import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { AppConfigModule } from './config/app-config.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { RouterState, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreFormSyncModule } from '@larscom/ngrx-store-formsync';
import { clearState, ROOT_REDUCERS } from './reducer';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { StaticDataModule } from './static-data/static-data.module';
import { AuthModule } from './features/auth/auth.module';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAnalyticsModule, ScreenTrackingService } from '@angular/fire/compat/analytics';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';

import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { PubSubService } from './shared/pubsub.service';
import 'intl-tel-input/build/js/utils';
import { LogMessageHandlerService } from './shared/logMessageHandler.service';
import { SharedService } from './shared/shared.service';
import {LocalDevExtremeModule} from "./dev-extreme/dev-extreme.module";
import { SessionStorageService } from './shared/sessionStorage.service';


export function playerFactory() {
  return player;
}


@NgModule({
  declarations: [AppComponent],
    imports: [
        BrowserModule,
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFireAnalyticsModule,
        AngularFirestoreModule,
        StoreModule.forRoot(ROOT_REDUCERS, {
            metaReducers: [clearState]
        }),
        EffectsModule.forRoot([]),
        // Only imported (and therefore only bundled) outside production builds --
        // previously this shipped in prod too, just set to logOnly.
        ...(!environment.production ? [StoreDevtoolsModule.instrument({ maxAge: 25 })] : []),

        StoreRouterConnectingModule.forRoot({
            stateKey: 'router',
            routerState: RouterState.Minimal
        }),

        AuthModule,
        CoreModule,
        SharedModule,
        StaticDataModule,
        AppConfigModule,
        HttpClientJsonpModule,
        HttpClientModule,
        StoreFormSyncModule.forRoot(),
        LottieModule.forRoot({player: playerFactory}),
        AppRoutingModule,
        // PrimengModule,
        BrowserAnimationsModule,
        // MessagesModule,
        // MessageModule,
        LocalDevExtremeModule
    ],
  providers: [
    // MessageService,
    // ConfirmationService,
    ScreenTrackingService,
    PubSubService,
    LogMessageHandlerService,
    SharedService,
    SessionStorageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
